







import {Component, Vue, Prop} from 'vue-property-decorator'
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import TimeEntriesDetailsList from '@/components/TimeEntriesDetailsList.vue';
import { User } from '@/models/user';

@Component({
    name: 'TimeEntriesDetails',
    components: {
        TimeEntriesDetailsList,
        NotLoggedPanel
    }
})
export default class TimeEntriesDetails extends Vue{
    @Prop() private user!: User;

}
